import { env } from '@/shared/lib/env';

/**
 * Resolves the signaling server URLs. Shared by the chat session and presence
 * client so both always target the same backend.
 *
 * The two origins come from the validated {@link env} object, not from
 * `import.meta.env` directly. They used to be read here behind a bracket-index
 * and a cast — which is what kept them out of the Zod schema and out of
 * `ImportMetaEnv` — with `http://localhost:3001` / `ws://localhost:3001` as
 * local fallbacks. Because Vite inlines these at BUILD time, a typo in
 * `.env.production` could not surface at runtime: the production bundle fell
 * back to a dev machine's loopback and the chat simply never connected. The
 * fallbacks still exist, as schema defaults, so an unset variable still means
 * "use the local signaling server in `server/`"; a malformed one now fails at
 * boot with the variable's name in the message.
 *
 * @module features/p2p-chat/lib/signalUrls
 */

export interface SignalUrls {
  /** HTTP origin (used for `/turn-creds`). */
  readonly http: string;
  /** WebSocket origin (used for `/signal/:room` and `/presence`). */
  readonly ws: string;
}

export function getSignalUrls(): SignalUrls {
  return { http: env.VITE_P2P_SIGNAL_URL, ws: env.VITE_P2P_WS_URL };
}
